<template>
	<nut-dialog
		teleport="body"
		title="提示"
		:visible="visible"
		ok-text="关闭"
		@ok="hanldleClose"
		no-cancel-btn
	>
		<div class="tips">
			<div class="item" v-for="tip in tips" :key="tip">
				{{ tip }}
			</div>
		</div>
	</nut-dialog>
</template>

<script>
import { computed } from 'vue';
import useDialog from '@/hooks/useDialog';
import tipMap from './tip.config.js';
export default {
	name: 'TipModal',
	setup() {
		const { handleCloseDialog, visible, type } = useDialog();
		const hanldleClose = () => {
			handleCloseDialog();
		};
		const tips = computed(() => tipMap[type.value || 'userinfo']);
		return {
			visible,
			hanldleClose,
			tips,
		};
	},
};
</script>

<style lang="scss" scoped>
.tips {
	text-align: left;
	.item {
		position: relative;
		padding-left: 10px;
		line-height: 18px;

		& + .item {
			margin-top: 6px;
		}
		&::before {
			position: absolute;
			left: 3px;
			top: 7px;
			display: block;
			content: '';
			width: 4px;
			height: 4px;
			border-radius: 50%;
			background: #999;
		}
	}
}
</style>
